import React from 'react';

import { Careers } from '@/features/careers/careers';

export function CareersPage() {
  return <Careers />;
}
